import { EyeOutlined } from '@ant-design/icons';
import { IAepnUpload } from '@nxsys/types/models/aepn/upload';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';

export const getUploadColumns = ({
  onClickView,
}: {
  onClickView: (record: IAepnUpload) => void;
}): ColumnsType<IAepnUpload> => [
  {
    key: 'action',
    title: 'Actions',
    fixed: 'left',
    align: 'left',
    width: 80,
    render: (record: IAepnUpload) => (
      <ul className="table-actions flex items-center justify-start">
        <li onClick={() => onClickView(record)}>
          <EyeOutlined />
        </li>
      </ul>
    ),
  },
  {
    key: 'errorMessage',
    title: 'Error Message',
    dataIndex: 'errorMessage',
    width: 400,
    render: (value: string | null) => (
      <div className={value ? 'text-red-500' : ''}>{value || '-'}</div>
    ),
  },
  {
    key: 'fileName',
    title: 'File Name',
    dataIndex: 'fileName',
    width: 300,
    render: (value: string) => <div style={{ wordBreak: 'break-word' }}>{value || '-'}</div>,
  },
  {
    key: 'taxYear',
    title: 'Tax Year',
    dataIndex: 'taxYear',
    align: 'right',
    width: 120,
    render: (value: number) => value || '-',
  },
  {
    key: 'companyId',
    title: 'Employer ID',
    dataIndex: 'companyId',
    width: 180,
    render: (value: string) => value || '-',
  },
  {
    key: 'employerRegistrationNumber',
    title: 'Employer Registration Number',
    dataIndex: 'employerRegistrationNumber',
    width: 280,
    render: (value: string) => value || '-',
  },
  {
    key: 'totalRecords',
    title: 'No. of Records',
    dataIndex: 'totalRecords',
    align: 'right',
    width: 150,
    render: (value: number) => value ?? '-',
  },
  {
    key: 'createdAt',
    title: 'Uploaded On',
    dataIndex: 'createdAt',
    align: 'right',
    width: 150,
    render: (value: string) => value ? moment(value).format('DD/MM/YYYY') : '-',
  },
  {
    key: 'uploadedBy',
    title: 'Imported By',
    dataIndex: 'uploadedBy',
    width: 200,
    render: (value: any) =>
      value ? `${value?.forename || ''} ${value?.surname || ''}`.trim() || '-' : '-',
  },
];
